import * as Configuration from "../configuration";

var ChartOverlay =
/** @class */
function () {
  function ChartOverlay(holder, options) {
    this.holder = holder;
    this.overlayElement = this.holder.querySelector("div.chart-wrapper div.chart-overlay");

    if (options) {
      this.overlayOptions = options;
    } else {
      this.overlayOptions = Configuration.options.BASE.overlay;
    }
  }

  ChartOverlay.prototype.show = function (type) {
    if (this.overlayElement) {
      this.overlayElement.parentNode.removeChild(this.overlayElement);
    }

    var overlay = document.createElement("div");
    overlay.classList.add("chart-overlay");
    overlay.innerHTML = this.overlayOptions.innerHTML[type ? type : "loading"];
    this.overlayElement = this.holder.querySelector("div.chart-wrapper").appendChild(overlay);
  };

  ChartOverlay.prototype.hide = function () {
    this.overlayElement.style.display = "none";
  };

  return ChartOverlay;
}();

export { ChartOverlay };